import React from 'react';
import { Container, Header, Icon } from 'semantic-ui-react';

const TestimonialView = ({ data }) => {
  return (
    <section
      className="testimonial-block"
      style={{
        '--bg-color': data.backgroundColor || '#163d4c',
        '--icon-color': data.iconColor || '#333333',
        '--text-color': data.textColor || '#f8f9fa',
        marginTop: '20px',
        marginBottom: '20px',
      }}
    >
      <Container>
        {data.quote && (
          <Header as="h4" textAlign="center" icon>
            <Icon name="quote right" circular />
            {data.quote}
          </Header>
        )}
        {data.person && (
          <div style={{ textAlign: 'center', marginTop: '1rem', fontWeight: 500 }}>
            — {data.person}
          </div>
        )}
      </Container>
    </section>
  );
};

export default TestimonialView;